import React from "react";
import {
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdb-react-ui-kit";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { mfmFramedUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";

import "./NewsSection.css";
import defaultImg from "images/tean02.jpg";

const NEWS_FORMAT_KEY = "ratio:16:9";

const toDataUri = (b64) => (b64 ? `data:image/jpeg;base64,${b64}` : "");

const fromBackendItem = (row) => ({
  id: row?.IDNoticia ?? row?.iDNoticia ?? null,
  slug: row?.slug ?? "",
  title: row?.titulo ?? "",
  text: row?.textoCorto ?? row?.texto ?? "",
  date: row?.fecha ?? "",
  image: row?.imageUuid
    ? mfmFramedUrl(row.imageUuid, 320, 180, NEWS_FORMAT_KEY)
    : (row?.base64img ? toDataUri(row.base64img) : defaultImg),
  imageUuid: row?.imageUuid ?? null,
  active: row?.active === 1 || row?.active === "1" || row?.active === true,
  sortOrder: Number(row?.sortOrder) || 0,
});

class NewsSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      news: [],
      perPage: 6,
      currentPage: 1,
    };
  }

  componentDidMount() {
    this.loadNews();
    this.loadPerPageConfig();
  }

  async loadPerPageConfig() {
    try {
      const response = await doFetch(
        "TEAN",
        "getSiteContentByPrefix?prefix=NEWS_",
        { method: "GET" }
      );
      if (!response || !response.ok) return;

      const contentType = response.headers?.get("content-type") || "";
      if (!contentType.includes("application/json")) return;

      const data = await response.json();
      if (data && data.STATE === "SUCCESS" && Array.isArray(data.DATA)) {
        const entry = data.DATA.find(
          (e) => e.contentKey === "NEWS_per_page"
        );
        if (entry && entry.configValue) {
          const val = parseInt(entry.configValue, 10);
          if (val > 0) this.setState({ perPage: val });
        }
      }
    } catch (_) {}
  }

  async loadNews() {
    if (this.props.onLoading) this.props.onLoading(true);
    try {
      const response = await doFetch("TEAN", "getNoticias", { method: "GET" });
      if (!response || !response.ok) {
        this.setState({ news: [] });
        return;
      }

      const contentType = response.headers?.get("content-type") || "";
      if (!contentType.includes("application/json")) {
        throw new Error(`Respuesta no JSON al cargar noticias (${response.status})`);
      }

      const data = await response.json();
      const rawItems = data && data.DATA ? data.DATA : [];
      const news = rawItems
        .map(fromBackendItem)
        .filter((item) => item.active)
        .sort((a, b) => b.sortOrder - a.sortOrder);
      this.setState({ news });
    } catch (error) {
      console.error("Error al obtener noticias:", error);
      this.setState({ news: [] });
    } finally {
      if (this.props.onLoading) this.props.onLoading(false);
    }
  }

  render() {
    const { news, perPage, currentPage } = this.state;
    const { onHandleNavLinks } = this.props;

    const totalPages = Math.max(1, Math.ceil(news.length / perPage));
    const safeCurrentPage = Math.min(currentPage, totalPages);
    const pageItems = news.slice(
      (safeCurrentPage - 1) * perPage,
      safeCurrentPage * perPage
    );

    return (
      <section className="news-section">
        <h2 className="section-title">Últimas noticias</h2>
        <MDBRow className="row-cols-1 row-cols-md-3 g-4">
          {pageItems.map((item, i) => (
            <MDBCol
              key={item.id}
            >
              <MDBCard
                className="h-100"
                style={{ cursor: item.slug ? "pointer" : "default" }}
                onClick={() => {
                  if (item.slug && onHandleNavLinks) {
                    onHandleNavLinks(null, `/noticia/${item.slug}`);
                  }
                }}
              >
                <MDBCardImage
                  src={item.image}
                  position="top"
                  alt={item.title}
                  className="news-image"
                />
                <MDBCardBody>
                  <MDBCardTitle>{item.title}</MDBCardTitle>
                  <MDBCardText>{item.text}</MDBCardText>
                  <small className="text-muted">{item.date}</small>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          ))}
        </MDBRow>
        {totalPages > 1 && (
          <nav className="d-flex justify-content-center mt-4">
            <ul className="pagination pagination-sm">
              <li className={`page-item ${safeCurrentPage <= 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => this.setState({ currentPage: safeCurrentPage - 1 })}>&laquo;</button>
              </li>
              {Array.from({ length: totalPages }, (_, i) => (
                <li key={i} className={`page-item ${i + 1 === safeCurrentPage ? "active" : ""}`}>
                  <button className="page-link" onClick={() => this.setState({ currentPage: i + 1 })}>{i + 1}</button>
                </li>
              ))}
              <li className={`page-item ${safeCurrentPage >= totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => this.setState({ currentPage: safeCurrentPage + 1 })}>&raquo;</button>
              </li>
            </ul>
          </nav>
        )}
      </section>
    );
  }
}

export default NewsSection;
